import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import InstallPWA from './components/InstallPWA';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
import Unauthorized from './pages/Unauthorized';

// Import placeholder components (akan dibuat)
import SuperAdminDashboard from './pages/SuperAdmin/Dashboard';
import JenisSurat from './pages/SuperAdmin/JenisSurat';
import FormJenisSurat from './pages/SuperAdmin/FormJenisSurat';
import KonfigurasiSurat from './pages/SuperAdmin/KonfigurasiSurat';
import AdminSurat from './pages/SuperAdmin/Surat';
import Users from './pages/SuperAdmin/Users';
import DataWarga from './pages/SuperAdmin/DataWarga';
import FormulirCetak from './pages/SuperAdmin/FormulirCetak';

import VerifikatorDashboard from './pages/Verifikator/Dashboard';
import VerifikatorSurat from './pages/Verifikator/SuratMasuk';
import VerifikatorRiwayat from './pages/Verifikator/RiwayatMobile';
import VerifikatorChangePassword from './pages/Verifikator/ChangePasswordMobile';

import WargaDashboard from './pages/Warga/DashboardMobile';
import WargaSurat from './pages/Warga/SuratMobile';
import WargaHistory from './pages/Warga/HistoryMobile';
import WargaProfile from './pages/Warga/ProfileMobile';
import ChangePassword from './pages/Warga/ChangePasswordMobile';
import RevisiSurat from './pages/Warga/RevisiSuratMobile';

import WargaUniversalDashboard from './pages/WargaUniversal/Dashboard';
import WargaUniversalHistory from './pages/WargaUniversal/History';
import WargaUniversalFormulir from './pages/WargaUniversal/FormulirCetak';

function App() {
  return (
    <AuthProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        {/* PWA Install Button - must be inside Router to use useLocation */}
        <InstallPWA />
        
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/unauthorized" element={<Unauthorized />} />

          {/* Super Admin Routes */}
          <Route
            path="/admin/dashboard"
            element={
              <PrivateRoute roles={['super_admin']}>
                <SuperAdminDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/jenis-surat"
            element={
              <PrivateRoute roles={['super_admin']}>
                <JenisSurat />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/jenis-surat/tambah"
            element={
              <PrivateRoute roles={['super_admin']}>
                <FormJenisSurat />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/jenis-surat/edit/:id"
            element={
              <PrivateRoute roles={['super_admin']}>
                <FormJenisSurat />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/konfigurasi"
            element={
              <PrivateRoute roles={['super_admin']}>
                <KonfigurasiSurat />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/surat"
            element={
              <PrivateRoute roles={['super_admin']}>
                <AdminSurat />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <PrivateRoute roles={['super_admin']}>
                <Users />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/data-warga"
            element={
              <PrivateRoute roles={['super_admin']}>
                <DataWarga />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/formulir-cetak"
            element={
              <PrivateRoute roles={['super_admin']}>
                <FormulirCetak />
              </PrivateRoute>
            }
          />

          {/* Verifikator (Admin RT/RW) Routes */}
          <Route
            path="/verifikator/dashboard"
            element={
              <PrivateRoute roles={['admin', 'verifikator']}>
                <VerifikatorDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/verifikator/surat"
            element={
              <PrivateRoute roles={['admin', 'verifikator']}>
                <VerifikatorSurat />
              </PrivateRoute>
            }
          />
          <Route
            path="/verifikator/riwayat"
            element={
              <PrivateRoute roles={['admin', 'verifikator']}>
                <VerifikatorRiwayat />
              </PrivateRoute>
            }
          />
          <Route
            path="/verifikator/change-password"
            element={
              <PrivateRoute roles={['admin', 'verifikator']}>
                <VerifikatorChangePassword />
              </PrivateRoute>
            }
          />
          <Route
            path="/verifikator/data-warga"
            element={
              <PrivateRoute roles={['admin']}>
                <DataWarga />
              </PrivateRoute>
            }
          />

          {/* Warga Routes */}
          <Route
            path="/warga/dashboard"
            element={
              <PrivateRoute roles={['warga']}>
                <WargaDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/warga/surat"
            element={
              <PrivateRoute roles={['warga']}>
                <WargaSurat />
              </PrivateRoute>
            }
          />
          <Route
            path="/warga/surat/revisi/:id"
            element={
              <PrivateRoute roles={['warga']}>
                <RevisiSurat />
              </PrivateRoute>
            }
          />
          <Route
            path="/warga/history"
            element={
              <PrivateRoute roles={['warga']}>
                <WargaHistory />
              </PrivateRoute>
            }
          />
          <Route
            path="/warga/profile"
            element={
              <PrivateRoute roles={['warga']}>
                <WargaProfile />
              </PrivateRoute>
            }
          />
          <Route
            path="/warga/change-password"
            element={
              <PrivateRoute roles={['warga']}>
                <ChangePassword />
              </PrivateRoute>
            }
          />

          {/* Warga Universal Routes */}
          <Route
            path="/warga-universal/dashboard"
            element={
              <PrivateRoute roles={['warga_universal']}>
                <WargaUniversalDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/warga-universal/history"
            element={
              <PrivateRoute roles={['warga_universal']}>
                <WargaUniversalHistory />
              </PrivateRoute>
            }
          />
          <Route
            path="/warga-universal/formulir"
            element={
              <PrivateRoute roles={['warga_universal']}>
                <WargaUniversalFormulir />
              </PrivateRoute>
            }
          />

          {/* Root opens the login form directly */}
          <Route path="/" element={<Login />} />

          {/* Default redirect */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
        
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </Router>
    </AuthProvider>
  );
}

export default App;

